const TERMINAL_STORAGE_KEY = "qrmenu_pos_terminal_id";

export const getTerminalId = () => {
  const saved = localStorage.getItem(TERMINAL_STORAGE_KEY);
  if (saved) return saved;
  const randomPart = window.crypto?.randomUUID
    ? window.crypto.randomUUID().replace(/-/g, "").slice(0, 10)
    : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;
  const terminalId = `WEB-${randomPart.toUpperCase()}`;
  localStorage.setItem(TERMINAL_STORAGE_KEY, terminalId);
  return terminalId;
};

